import statuses from '@/settings/statuses';
import moment from 'moment-timezone';
export default function parseStatuses(mail) {
  if (!mail.status_label) return [];

  let split = mail.status_label
    .split('. ')
    .join(', ')
    .split(', ');
  let result = [];
  let stopIteration = false;
  let itemRequested = false;
  split.forEach(status => {
    let statusClass = '';
    if (stopIteration) return;

    if (
      statuses.terminalMailActions.includes(status) ||
      status.includes('Mail forwarded in group')
    ) {
      stopIteration = true;
      result = [];
    } else {
      if (status == 'New') {
        statusClass = 'new';
      } else if (statuses.urgent.includes(status)) {
        statusClass = 'danger urgent';

        if (!itemRequested) itemRequested = true;
      } else if (statuses.exbidite.includes(status)) {
        statusClass = 'danger exbedite';

        if (!itemRequested) itemRequested = true;
      } else if (statuses.regular.includes(status)) {
        statusClass = 'req';

        // TEMP
        if (status == 'Marked as pick up requested by the user')
          status = 'Marked as pick up requested by user';

        if (!itemRequested) itemRequested = true;
      }

      if (status == 'Pick up requested' && mail.pick_up_scheduled_at)
        status = `Pick up scheduled on ${moment(
          mail.pick_up_scheduled_at.split('Z')[0]
        ).format('D MMM, YYYY [at] h:mm a')}`;

      if (status === 'Check deposited' && mail.check_deposited_date)
        status = `Check deposited ${moment(
          mail.check_deposited_date
        ).format('D MMM, YYYY')}`;

      if (status === 'Junk Mail') {
        if (moment(mail.trashed_date) > moment())
          status = `Junk Mail (discard after ${moment(
            mail.trashed_date
          ).diff(moment(), 'days') + 1} days)`;
      }

      if (status === 'Trash requested') {
        status = 'Discard requested';
        statusClass = 'req';
      }
    }

    result.push({
      value: status,
      class: statusClass,
    });
  });
  return result.sort((a, b) => {
    if (!a.class && b.class) return 1;

    if (a.class && !b.class) return -1;
  });
}
